import {DateTime} from "luxon";
import cpacStore from "../cpac-store.ts";
import {config} from "../config.ts";

export const parseDate = (str: string | undefined) => {
    if (!str) return undefined
    // DateTime.fromISO, not Date.parse: the Date.parse fallback for non-ISO input is
    // implementation-defined (Chrome reads a wall-clock string as browser-local time;
    // Safari yields NaN). fromISO makes anything off-contract deterministically invalid.
    const dt = DateTime.fromISO(str);
    // An invalid DateTime is truthy — it would sail through every downstream falsy
    // guard (the CPACWEB-277 filters) and render literal "Invalid DateTime" text.
    if (!dt.isValid) return undefined
    return dt;
}

export const isToday = (date: DateTime) => {
    // Same calendar day in the user's selected timezone. (The former weekday-name
    // comparison matched any date exactly N*7 days away, in the browser zone.)
    const tz = cpacStore.getState().timezone;
    return date.setZone(tz).hasSame(DateTime.now().setZone(tz), "day");
}

export const normalizeLiveDateTime = (date: DateTime | undefined) => { // add for liveDateTime
    if (!date) return undefined

    const utcDate = date.toUTC()
    if (utcDate.hour >= 5) return utcDate

    return utcDate.startOf("day").plus({ hours: 5 })
}

export const setUserTimeZone = (tz: string) => {
    localStorage.setItem("cpacSelectedTimeZone", tz)
    cpacStore.setTimezone(tz)
}

export const initUserTimeZone = () => {
    const tz = localStorage.getItem("cpacSelectedTimeZone")
    if (tz) {
        cpacStore.setTimezone(tz)
    } else {
        const autoTZ = Intl.DateTimeFormat().resolvedOptions().timeZone
        if (autoTZ) {
            setUserTimeZone(autoTZ)
        } else {
            setUserTimeZone(config.defaultTimeZone)
        }
    }
}